import React from "react";
import { useTheme } from "@emotion/react";
import {
  Backdrop,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getProduct, updateProduct } from "../../actions/productActions";
import { CustomSelectComponent } from "../../components/forms/CustomSelectComponent";
import { listcategory } from "../../actions/categoryActions";
import { listStores } from "../../actions/storeActions";
import { listBrand } from "../../actions/brandActions";
import { listAttributes } from "../../actions/attributeActions";
import { PRODUCT_UPDATE_RESET } from "../../constants/productContansts";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sku: Yup.string().required("SKU is required"),
  image: Yup.string().required("Image is required"),
  price: Yup.number().required("Price is required"),
  qty: Yup.number().required("Qty is required"),
  description: Yup.string().required("Description is required"),
  store: Yup.string().required("Store is required"),
  brand: Yup.string().required("Brand is required"),
  category: Yup.string().required("Category is required"),
  color: Yup.string().required("Color is required"),
  size: Yup.string().required("Size is required"),
  available: Yup.boolean().required("Available is required"),
});

const EditProduct = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productGet = useSelector((state) => state.productGet);
  const { loading, product } = productGet;

  const productUpdate = useSelector((state) => state.productUpdate);
  const { loading: updateLoading, success, error } = productUpdate;

  const storeList = useSelector((state) => state.storeList);
  const { loading: storeLoading, stores } = storeList;

  const categoryList = useSelector((state) => state.categoryList);
  const { loading: catLoading, categories } = categoryList;

  const brandList = useSelector((state) => state.brandList);
  const { loading: brandLoading, brands } = brandList;

  const attributeList = useSelector((state) => state.attributeList);
  const { loading: attrLoading, attributes } = attributeList;

  const params = useParams();
  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      dispatch({ type: PRODUCT_UPDATE_RESET });
      navigate("/products");
      toast("Product updated successfully");
    }
    dispatch(getProduct(params.id));
    dispatch(listcategory());
    dispatch(listStores());
    dispatch(listBrand());
    dispatch(listAttributes());
  }, [userInfo, dispatch, navigate, success, params.id]);

  const handleSubmit = async ({
    name,
    image,
    sku,
    price,
    qty,
    description,
    store,
    brand,
    category,
    color,
    size,
    available,
  }) => {
    dispatch(
      updateProduct({
        _id: params.id,
        name,
        image,
        sku,
        price,
        qty,
        description,
        store,
        brand,
        category,
        attributes: { color, size },
        available,
      })
    );
  };
 

  return (
    <Container>
      {loading ||
        updateLoading ||
        storeLoading ||
        catLoading ||
        brandLoading ||
        (attrLoading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ))}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Edit Product
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {product && (
            <Form
              initialValues={{
                name: product.name,
                sku: product.sku,
                image: product.image,
                price: product.price,
                qty: product.qty,
                description: product.description,
                store: product.store,
                brand: product.brand,
                category: product.category,
                color: product.attributes[0].color,
                size: product.attributes[0].size,
                available: product.available,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <InputComponent label="name" />
              <InputComponent label="sku" />
              <InputComponent label="image" />
              <InputComponent label="price" type={"number"} />
              <InputComponent label="qty" type={"number"} />
              <InputComponent label="description" multiline maxRows={8} />
              <CustomSelectComponent name={"store"} item={stores} />
              <CustomSelectComponent name={"brand"} item={brands} />
              <CustomSelectComponent name={"category"} item={categories} />
              <CustomSelectComponent name={"color"} item={attributes} />
              <CustomSelectComponent name={"size"} item={attributes} />
              <RadioButtonComponent name="available" />
              <SubmitButton title={"Edit Product"} />
            </Form>
          )}
        </div>
      </Box>
    </Container>
  );
};

export default EditProduct;
